// src/utils/rolePermissions.js
export const rolePermissions = {
  1: {
    // 客户
    customerManagement: {
      canAdd: false,
      canEdit: false,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: false,
    },
    homepage: {
      canViewVolumeTrend: false,
      canViewTeleSales: false,
      canViewOperationQuality: false,
      canViewFineSituation: false,
    },
    waybillManagement: {
      canQuery: false,
      canDelete: false,
      canAdd: false,
      canUpdate: false,
      canExportWaybill: false,
      canDeleteWaybill: false,
      canExport: false,
    },
    profitReport: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: false,
    },
  },
  2: {
    // 管理员
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canExport: true,
      canImport: true,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: true,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: true,
      canExport: true,
    },
    profitReport: {
      canQuery: true,
      canExport: true,
      canEdit: true,
    },
    commissionDetail: {
      canQuery: true,
      canExport: true,
      canEdit: true,
    },
    companyCostSheet: {
      canExport: true,
      canEdit: true,
    },
    userManagement: {
      canAdd: true,
    },
  },
  3: {
    // 财务
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canExport: false,
      canImport: true,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: true,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: true,
      canExport: false,
    },
    profitReport: {
      canQuery: true,
      canExport: false,
      canEdit: true,
    },
    commissionDetail: {
      canQuery: true,
      canExport: false,
      canEdit: true,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: true,
    },
    userManagement: {
      canAdd: false,
    },
  },
  // 根据实际情况继续添加其他角色的权限
  4: {
    // 经理
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canExport: true,
      canImport: true,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: true,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: true,
      canExport: true,
    },
    profitReport: {
      canQuery: true,
      canExport: true,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: true,
      canExport: true,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: true,
      canEdit: true,
    },
    userManagement: {
      canAdd: true,
    },
  },
  5: {
    // 运作主管
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: true,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: false,
      canExport: true,
    },
    profitReport: {
      canQuery: true,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: true,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: true,
    },
  },
  6: {
    // 运作
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: false,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: false,
      canExport: false,
    },
    profitReport: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: false,
    },
  },
  7: {
    // 电销主管
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: false,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: false,
      canViewFineSituation: false,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: false,
      canAdd: true,
      canUpdate: false,
      canExportWaybill: true,
      canDeleteWaybill: false,
      canExport: false,
    },
    profitReport: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: true,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: true,
    },
  },
  8: {
    // 电销
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: false,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: false,
      canViewFineSituation: false,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: false,
      canAdd: true,
      canUpdate: false,
      canExportWaybill: true,
      canDeleteWaybill: false,
      canExport: false,
    },
    profitReport: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: false,
    },
  },
  9: {
    // 面销主管
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canExport: false,
      canImport: true,
      canQuery: true,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: true,
      canAdd: true,
      canUpdate: true,
      canExportWaybill: true,
      canDeleteWaybill: true,
      canExport: false,
    },
    profitReport: {
      canQuery: true,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: true,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: true,
    },
  },
  10: {
    // 面销
    customerManagement: {
      canAdd: true,
      canEdit: true,
      canDelete: false,
      canExport: false,
      canImport: false,
      canQuery: false,
    },
    homepage: {
      canViewVolumeTrend: true,
      canViewTeleSales: true,
      canViewOperationQuality: true,
      canViewFineSituation: true,
    },
    waybillManagement: {
      canQuery: true,
      canDelete: false,
      canAdd: true,
      canUpdate: false,
      canExportWaybill: true,
      canDeleteWaybill: false,
      canExport: false,
    },
    profitReport: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    commissionDetail: {
      canQuery: false,
      canExport: false,
      canEdit: false,
    },
    companyCostSheet: {
      canExport: false,
      canEdit: false,
    },
    userManagement: {
      canAdd: false,
    },
  },
  // 继续添加其他角色权限
};

export default rolePermissions;
